import { useEffect, useState } from 'react';

const useQuantityDeliveryTabs = (parcels = [], defaultTab = 'quantity') => {
  const [parcelTabs, setParcelTabs] = useState({});

  useEffect(() => {
    const nextTabs = {};
    parcels.forEach(parcel => {
      nextTabs[parcel.id] = defaultTab;
    });
    setParcelTabs(nextTabs);
  }, [parcels, defaultTab]);

  const toggleParcelTab = (parcelId, tab) => {
    setParcelTabs(prev => ({ ...prev, [parcelId]: tab }));
  };

  return { parcelTabs, toggleParcelTab };
};

export default useQuantityDeliveryTabs;
